var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c(_setup.QuoteUnitsTable,{attrs:{"freight":"","value":_setup.shipment.units},on:{"next":function($event){return _setup.emits('next')}}}),_c('form-divider'),_c(_setup.PackageFreightOptions,{attrs:{"quoting":"","value":_setup.shipment.freight}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }